const common = {
  Loading: "読み込み中",
  signUp: "登録",
  login: "ログイン",
  logout: "ログアウト",
  email: "電子メール",
  emailFormatErrorTips: "メール形式​が正しくありません",
  emailDifferentTips: "両方のフィールドに同じメールアドレスを入力してください。",
  emailRegisteredTips: "このメールアドレスは登録済みです。別のメールアドレスを選択してください。",
  password: "パスワード",
  passwordFormatErrorTips: "パスワードには、文字数が8文字以上50文字以下で、英数字、特殊文字が少なくとも2種類含まれてください。",
  passwordDifferentTips: "両方のフィールドに同じパスワードを入力してください。",
  verificationCode: "確認コード",
  verificationCodeErrorTips: "認証コードが正しくありません",
  confirm: "確認",
  cancel: "キャンセル",
  submit: "送信",
  confirmEmail: "メールアドレスを確認する",
  formEmptyErrorTips: "空白にすることはできません",
  country: "国/地域",
  birthday: "生年月日",
  anonymous: "匿名",
  name: "名前",
  nameFormatErrorTips: "ユーザー名は50文字以内にする必要があり、特殊文字は使用できません",
  okBtn: "了解",
  serverErrorTips: "リクエストにエラーが発生しました。しばらくしてからもう一度お試しください。",
  updateSuccessTips: "変更に成功しました。",
  authorizationExpiredErrorTips: "認証の有効期限が切れました。再度ログインしてください。",
  requestFrequentlyErrorTips: "リクエストが多過ぎます。しばらくしてからもう一度お試しください。",
};

export default common;
